import { SelectableStudent } from "./StudentCheckboxSelector";

export function sortStudentsAlphabetically(students: SelectableStudent[]): SelectableStudent[] {
	return students.sort((a, b) => {
		return a.label.localeCompare(b.label);
	});
}
